<div class="history-graph" [style.width]="buildHistory.length*10">
    <div *ngFor="let build of buildHistory" 
      class="history-bar {{build.build.result||build.build.status}}"
      (click)="openLinkInNewTab(build.build.webLink)" 
      matTooltip="{{tooltipInfo(build.build)}}"
      matTooltipShowDelay="500"
      [style.height]="build.height" [style.left]="build.left">
    </div>
</div>